import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Layout from '../../layouts/page';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { config } from '../../config';
import Spinner from '../../components/spinner';
import Backbtn from '../../components/backbtn';

const ViewEstateMember = () => {
  const [member, setMember] = useState({
    id: '',
    estate_id: '',
    name: '',
    email: '',
    phone_number: '',
    status: '',
    created_at: '',
    updated_at: '',
  });
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const storedToken = localStorage.getItem('auth_token');

  useEffect(() => {
    document.title = 'Tuwe | Member Details';

    const fetchData = async () => {
      if (!storedToken) {
        toast.error('Authentication token is missing. Please log in again.');
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${config.api_path}/estate-members/${id}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        });

        console.log('API Response:', response.data); // Log the response

        if (response.data) {
          setMember(response.data.data);
        } else {
          toast.error('No data found for this member.');
        }
      } catch (error) {
        console.error('Error fetching member data:', error.response?.data || error.message); // Log detailed error

        if (error.response?.status === 404) {
          toast.error('Member not found.');
        } else {
          toast.error('Failed to fetch data. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, storedToken]);

  console.log({member});

  return (
    <Layout>
      <div className="container">
        <div className="profile-card">
          <div className="profile-header">
            <h3 style={{ textAlign: 'center' }}>{member.name}</h3>
          </div>
          <Backbtn />
          {loading ? (
            <Spinner />
          ) : (
            <div className="row">
              <div className="col-md-6" style={{ marginTop: '50px', backgroundColor: '#F3F3F3', padding: '20px' }}>
                {/* Member Details Section */}
                <div className="details-section">
                  <p><strong>ID:</strong> {member.id}</p>
                  <p><strong>Estate ID:</strong> {member.estate_id}</p>
                  <p><strong>Email:</strong> {member.email}</p>
                  <p><strong>Phone Number:</strong> {member.phone_number}</p>
                  <p><strong>Status:</strong> {member.status}</p>
                  <p><strong>Created At:</strong> {member.created_at}</p>
                  {/* <p><strong>Updated At:</strong> {member.updated_at}</p> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </Layout>
  );
};

export default ViewEstateMember;